import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const InterestGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'rateDate',
        headerName: 'Rate Date',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 100,
    },

    {
        field: 'rate',
        headerName: 'Rate',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 100,
    },
    {
        field: 'source',
        headerName: 'Source',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'effectiveDate',
        headerName: 'Effective Date',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'expiredOn',
        headerName: 'Expired On',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
];
